import React from "react";
import Footer from "../../components/foot";
import "./index.css";


function MyServicePage(){

	return(
		<React.Fragment >

			<header id='freehead'>
				<h1 className='hollywood'> IBRAHIM B. ODUOLA </h1>
				<h3 className='arts'> A special Kind of Developer </h3>

				<div className='btn-gp'>
					<a className='sharp' href="/#contact-me" > Book Me </a>
					<a className='sharp' href="/about/" > About Ibrahim </a>
				</div>

			</header>

			<main id='freehand'>
				<h2 className='rock'> HI! MY NAME IS IBRAHIM... </h2>
				<p className='spiral' >... and I refuse to stop at average.</p>

				<p className='pleasing'> 
					Developing a website or application that satisfies your every need doesn't have to be hard, don't you agree? As 
					a normal human being, you know what you want and what you need. You know what you want to see and you know what 
					feels right and what does not. And as a non-tech person, you don't have to know about web or server-side development
					or even what fancy word to use before getting your needs met.
	    		</p>
	    		<p className='pleasing'> 
					This is where my specialty comes in. As a human myself, I can communicate in simple languages with you and determine 
					with my tech super power ;) what would work best for you and how to get it done well and quickly. When it comes to my work
					as a freelancing developer, security, speed and looks are of top priority to me and that's why we have to work together.
    			</p>

    			<div className='frame'> <img src="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/whitewebresponsive.webp" alt="the brilliant web work of Web Developer Ibrahim B. Oduola" loading="lazy" /> </div>
		
				<h2 className='rock'>WHO DO I BUILD WEBSITES FOR?</h2>

				<div className='spread'>
					
					<article className='square'>
						<h3 className='rock'>Start Ups And Rejuvinating Businesses</h3>
						<p className='pleasing'> 
							As a start-up or rejuvinating business, it is easy to get thrown out by the big boys on the internet. And that is 
							a very big problem today because of the value of a strong online presence and that makes the competition is tough 
							and worldwide. But you would have to worry about that when we work together. 
						</p>
						<p className="pleasing">
						 	I have worked with start-ups a number
							of start-ups (some of which are mine) in the past and I understand the need to make excellent first impressions on
							clients and to hit the ground running. <span> I WOULD MAKE YOU PARTY WITH THE BIG BOYS ON THE INTERNET!</span>
		    			</p>

					</article>

					<article className='square'>
						<h3 className='rock'> Retail Commercial Stores </h3>
						<p className='pleasing'> 
							It always business when commerce is involved and even when commerce goes online (and becomes ecommerce), it is still
							business as usual. Ecommerce is parhaps the biggest and most common use of the internet today and yet, some commercial 
							stores do not profit from it. Why does this happen? many reasons ofcourse which can be summed up into a simple statement
							"the ecommerce platform is not encouraging enough for people to spend their money on it". 
						</p>
						<p className="pleasing">
							Making e-commerce platform is
							not an art but a science; science which I have studied and experimented with. If you want to sell online, It has to 
							suit the need of potential buyers.
							<a href="/#contact-me">Book me now, let's make profit for you.</a>
		    			</p>
		    			
					</article>

					<article className='square'>
						<h3 className='rock'>Application/Software makers</h3>
						<p className='pleasing'> 
							Applications and softwares (running on web or mobile devices) varies in forms, sizes and in infrastructures. 
							Getting more than what you need will make you pay unnecessary bills and getting less than what is required...well...
							that would not just work...
						</p> 
						<p className='pleasing'> 
							Security is the most important issue here and you need someone who is very very security-conscious and luckily 
							for you, you are currently reading the profile of someone that has NEVER been hacked :). I am ver security-conscious 
							and I got you covered!.
		    			</p>
					</article>

					<article className='square'>
						<h3 className='rock'>Influencers, Photographers and Creators</h3>
						<p className='pleasing'> 
							The feel of personal brand on the internet is important. For influencers, photographers and creators, 
							the website page has to feel right. In this case, communication is probably more important than the
							job itself. And without the technical know-how, it is easy to get stuck with something that's sorta 
							like your style rather than exactly your style. This is just not good enough and it's basically a 
							downward spiral from there on.
						</p> 
						<p className='pleasing'> 
							Users must feel the spirit in which your creative works embody and that's my job to do.
		    			</p>

					</article>
    			
    			</div>

    			<div className='btn-gp stand'>
    				<a href="/#previous-work" className='sharp'> My previous Work </a>
    				<a href="/blog/" className='sedated'> See My Blog </a>
    				<a href="/" className='sedated'> Home Page </a>
    			</div>
			

			</main>

			<Footer />

		</React.Fragment>
		)
};

export default MyServicePage;